var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_c('el-dialog',{attrs:{"title":"正在下载新版本","visible":_vm.visible,"width":"30%","show-close":false,"close-on-click-modal":false},on:{"update:visible":function($event){_vm.visible=$event}}},[_c('el-progress',{attrs:{"percentage":_vm.percentage}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }